<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listRecordSituations"
        :title-table="$t('Record Situations')"
        module="recordSituationsSettingsModule"
        sort-name="nome"
        add-permission="ROLE_SITUACAO_REGISTRO_INSERIR"
        view-permission="ROLE_SITUACAO_REGISTRO_CONSULTAR"
        edit-permission="ROLE_SITUACAO_REGISTRO_ATUALIZAR"
        delete-permission="ROLE_SITUACAO_REGISTRO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormRecordSituations v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormRecordSituations from "./forms/FormRecordSituations.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormRecordSituations,
  },
  computed: {
    ...mapState("recordSituationsSettingsModule", {
      listRecordSituations: (state) => state.listRecordSituations,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Descrição",
          field: "nome",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "recordSituationsSettingsModule/prepareToEditRecordSituations",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
